export function createNode(tagName, cssClass, attributes) {
	const result = document.createElement(tagName);
	if (cssClass) {
		for (let cssClassPart of cssClass.split(' ')) {
			result.classList.add(cssClassPart);
		}
	}
	if (typeof attributes === 'object') {
		Object.assign(result, attributes);
	}
	return result;
}

export function elementInScopeVertically(element, topOffset = 0) {
	const rect = element.getBoundingClientRect();
	const viewHeight = Math.max(document.documentElement.clientHeight, window.innerHeight);
	return rect.bottom > topOffset && rect.top - viewHeight < 0;
}

export function scrollToElementHorizontallyIfNeed(element, scrollableBlock) {
	if (!element || !scrollableBlock)
		return;

	const elementLeft = element.offsetLeft + element.offsetWidth;
	const scrollableBlockLeft = scrollableBlock.offsetLeft + scrollableBlock.offsetWidth;
	// check if element not in view
	if (elementLeft >= scrollableBlockLeft + scrollableBlock.scrollLeft) {
		scrollableBlock.scrollLeft = elementLeft - scrollableBlockLeft;
	} else if (element.offsetLeft <= scrollableBlock.offsetLeft + scrollableBlock.scrollLeft) {
		scrollableBlock.scrollLeft = element.offsetLeft - scrollableBlock.offsetLeft;
	}
}